import React from "react";
import { FaPhoneAlt, FaUtensils, FaFileInvoiceDollar, FaTruck, FaSmile } from "react-icons/fa";
import { SITE_CONTENT } from "../content";

const stepIcons = [
  <FaPhoneAlt className="w-5 h-5 text-[#E8A040]" />,
  <FaUtensils className="w-5 h-5 text-[#E8A040]" />,
  <FaFileInvoiceDollar className="w-5 h-5 text-[#E8A040]" />,
  <FaTruck className="w-5 h-5 text-[#E8A040]" />,
  <FaSmile className="w-5 h-5 text-[#E8A040]" />
];

const HowItWorksSection = () => {
  const { title, steps } = SITE_CONTENT.pages.homePage.howItWorks;

  return (
    <section className="bg-[#f8f5ee] text-[#1c2e22] py-24 lg:py-32 relative overflow-hidden" id="how-it-works">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 relative z-10">
        
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-20">
          <span className="inline-block px-4 py-1.5 rounded-full bg-[#1b4329]/10 text-[#1b4329] text-xs font-bold tracking-[0.25em] uppercase mb-4 border border-[#1b4329]/20">
            Effortless For Hosts
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-light font-serif leading-tight text-[#0a1a0f] mb-4">
            {title}
          </h2>
          <div className="w-20 h-1 bg-gradient-to-r from-[#D4AF37] to-[#E8A040] mx-auto rounded-full" />
        </div>

        {/* 5-Step Connected Flow Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-6 relative">
          {steps.map((step, idx) => (
            <div
              key={idx}
              className="flex flex-col justify-between p-6 rounded-2xl bg-white border border-[#e5ddd0] shadow-sm hover:shadow-xl hover:border-[#E8A040] transition-all duration-300 relative group"
            >
              {/* Step indicator header */}
              <div>
                <div className="flex items-center justify-between mb-5">
                  <div className="w-12 h-12 rounded-xl bg-[#092212] flex items-center justify-center shadow-md group-hover:scale-105 transition-transform">
                    {stepIcons[idx]}
                  </div>
                  <span className="text-2xl font-serif font-bold text-[#D4AF37]/40 group-hover:text-[#D4AF37] transition-colors">
                    0{step.number}
                  </span>
                </div>

                <h3 className="font-semibold text-base sm:text-lg text-[#0a1a0f] mb-3 leading-snug">
                  {step.title}
                </h3>

                <p className="text-sm text-[#526056] leading-relaxed font-light">
                  {step.description}
                </p>
              </div>

              {/* Progress step bar */}
              <div className="mt-6 pt-4 border-t border-[#f0ebe0] flex items-center justify-between text-xs text-[#8c9c90] font-medium">
                <span>Step {step.number} of 5</span>
                <span className="text-[#b8731b] font-bold">&rarr;</span>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom CTA Hook */}
        <div className="mt-16 text-center">
          <a
            href="#booking-section"
            className="inline-flex items-center gap-3 px-8 py-4 bg-[#0a1a0f] hover:bg-[#13351f] text-white text-xs font-bold tracking-[0.15em] uppercase rounded-full shadow-lg hover:scale-105 transition-all duration-300"
          >
            Start Your Catering Enquiry &rarr;
          </a>
        </div>

      </div>
    </section>
  );
};

export default HowItWorksSection;

